<button type="{{type}}" class="button {{variation}}" [ngClass]="{'button--icon' : icon !== ''}" (click)="onClick()" [disabled]="disableButton">{{ text }} <img src="{{icon}}" alt=""></button>
